import React, { FunctionComponent } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { Routes } from '../../routes';

interface PrivateRouteProps extends RouteProps {
  isLoggedIn: boolean;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ isLoggedIn, ...rest}) => {
  if (!isLoggedIn) {
    return <Redirect to={Routes.LOGIN} />;
  } else {
    return <Route { ...rest } />
  }
};

export default PrivateRoute;
